import { Flex } from '@chakra-ui/react';
import TCAPLoader from 'components/TCAPLoader';

/** Page-level loading state for service profile forms, matching the dashboard spinner. */
export default function ServiceProfileLoader() {
    return (
        <Flex justify="center" mt="10rem" role="status" aria-label="Loading">
            <TCAPLoader showText={false} scale={3} />
        </Flex>
    );
}
